var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
function SvgHistoryLogo05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 52,
    viewBox: "0 0 240 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#030303;}.b{fill:#fff;}.c{fill:#480f72;}.d{fill:#8e6cab;}.e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(58.213 18.798)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-497.763,961.731h-18.694v4.589h6.679v17.259h5.306V966.32h6.709Z",
    transform: "translate(516.457 -961.358)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-479.938,961.732l-9.3,21.847h5.619l1.216-3.182h8.77l1.187,3.182h5.9l-8.926-21.847Zm-.812,14.294,2.842-7.739,2.653,7.739Z",
    transform: "translate(503.946 -961.359)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-437.8,978.706c-3.5,0-5.487-2.685-5.487-6.368,0-3.714,2.054-6.429,5.675-6.429a4.979,4.979,0,0,1,4.368,2.372l4.308-3.091a10.452,10.452,0,0,0-8.676-4.15c-7.361,0-11.261,5.055-11.261,11.3s3.869,11.3,11.2,11.3a11.475,11.475,0,0,0,9.144-3.965l-4.4-3.277a5.744,5.744,0,0,1-4.869,2.311",
    transform: "translate(485.393 -961.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-399.524,961.041c-6.961,0-11.174,5.056-11.174,11.3s4.213,11.3,11.174,11.3c6.9,0,11.142-5.057,11.142-11.3s-4.245-11.3-11.142-11.3m0,17.633c-3.527,0-5.586-2.683-5.586-6.335,0-3.714,2.059-6.429,5.586-6.429,3.5,0,5.556,2.715,5.556,6.429,0,3.652-2.06,6.335-5.556,6.335",
    transform: "translate(467.845 -961.041)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-340.351,971.753a4.822,4.822,0,0,0,3.026-4.868c0-3.246-2.559-5.15-7.584-5.15h-8.426v21.848h9.488c5.554,0,8.239-2.028,8.239-6.273,0-2.933-1.653-4.9-4.743-5.556m-7.959-5.773h2.092c2.559,0,3.589.531,3.589,2.09,0,1.654-1,2.279-3,2.279h-2.684Zm3.154,13.046h-3.154V974.5h3.247c2.84,0,4.057.626,4.057,2.279,0,1.748-.938,2.248-4.15,2.248",
    transform: "translate(441.478 -961.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-311.26,974.75h9.239v-4.432h-9.239v-3.994h11.079v-4.589h-16.384v21.847h16.633V979H-311.26Z",
    transform: "translate(424.577 -961.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-275.662,961.734h-5.308v21.848h14.951v-4.587h-9.643Z",
    transform: "translate(408.216 -961.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-243.194,961.734H-248.5v21.848h14.951v-4.587h-9.645Z",
    transform: "translate(393.291 -961.36)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-212.8,993.68l-.712,1.418-.712-1.418h-.317v2.338h.317v-1.686l.559,1.106h.306l.559-1.106v1.686h.312V993.68Z",
    transform: "translate(377.68 -976.044)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M-218.285,993.97h.645v2.048h.318V993.97h.651v-.29h-1.614Z",
    transform: "translate(379.403 -976.043)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-573.467,951.617a25.365,25.365,0,0,0-25.361-25.365,25.365,25.365,0,0,0-25.36,25.365c0,.008,0,.016,0,.025v19.74a.819.819,0,0,0,.821.82h49.08a.821.821,0,0,0,.82-.82Z",
    transform: "translate(624.189 -926.252)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-568.653,970.71c-.864-2.137-8.261-.533-18.556,4.991-10.058,5.4-15.983,11.641-15.094,13.5.941,1.967,11.27.584,19.565-4.009,11.244-6.222,15.163-11.819,14.085-14.478",
    transform: "translate(614.169 -946.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M-588.588,992.561a6.294,6.294,0,0,1-4.553-1.823,44.825,44.825,0,0,1,10.084-7.232,6.353,6.353,0,0,1,.636,2.624,6.307,6.307,0,0,1-6.167,6.431",
    transform: "translate(609.918 -952.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-618.751,974.919a4.531,4.531,0,0,0,2.022,1.243c.023.005.275.092.275.092h-6.914a.82.82,0,0,1-.82-.82v-19.74c0-.01,0-.018,0-.026a25.335,25.335,0,0,1,10.568-20.6h0l-.289.346a2.546,2.546,0,0,0-.179,2.782c.266.738-.541,1.578-.971,2.049a14.048,14.048,0,0,0-3.873,9.492c-.192,4.332,1.082,8.174,1.519,10.2a22.6,22.6,0,0,1,.562,3.262c1.638-1.383,3.389-2.732,5.159-3.969,2.842-1.873,5.153-3.263,7.175-4.351,4.538-2.441,5.7-2.18,2.119-.086a60.915,60.915,0,0,0-9.427,6.65c-9.272,8.36-7.888,12.491-6.923,13.476",
    transform: "translate(624.189 -930.302)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M-558.313,991.474a.822.822,0,0,1-.82.821H-591.22s.435-.091.459-.1a50.419,50.419,0,0,0,14.16-5.427c9.923-5.134,16.426-11.754,18.146-16.581l.082-.226s.005.072.014.22c.027.4.046,1.014.046,1.525v19.765",
    transform: "translate(609.035 -946.344)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M-597.765,928.8h0a25.26,25.26,0,0,1,11.081-2.545,25.375,25.375,0,0,1,24.5,18.8,4.637,4.637,0,0,0-1.283-.76,13.087,13.087,0,0,0-2.749-.758,14.7,14.7,0,0,1-4.95-1.353c-3.234-1.768-7.54-9.337-14.435-11.338a14.832,14.832,0,0,0-6.874-.38c-.561.1-1.706.218-2.11-.314-.817-1.075-1.434-1.706-2.7-1.473-.165.031-.481.123-.481.123",
    transform: "translate(612.043 -926.252)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 240,
    height: 52
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryLogo05);
export default __webpack_public_path__ + "static/media/history_logo_05.68881953bfd2d698976dca501fe84098.svg";
export { ForwardRef as ReactComponent };